import aa from "../AdminPortal/adminApp.module.css";

export default function JournalOfflineBanner({
  isOnline,
  pendingCount,
  isSyncing,
  lastSyncError,
  onSync,
}) {
  if (isOnline && pendingCount === 0 && !lastSyncError) return null;

  const offline = !isOnline;
  const text = offline
    ? pendingCount > 0
      ? `Офлайн · ${pendingCount} отметок ждут отправки`
      : "Офлайн · данные из кэша"
    : pendingCount > 0
      ? isSyncing
        ? `Синхронизация… (${pendingCount})`
        : `${pendingCount} отметок не отправлено`
      : lastSyncError;

  return (
    <div
      className={`${aa.journalOfflineBanner} ${offline ? aa.journalOfflineBannerOffline : aa.journalOfflineBannerPending}`}
      role="status"
    >
      <span className={aa.journalOfflineBannerText}>{text}</span>
      {!offline && pendingCount > 0 && !isSyncing ? (
        <button type="button" className={aa.journalOfflineBannerBtn} onClick={onSync}>
          Отправить
        </button>
      ) : null}
    </div>
  );
}
